export default "__VITE_ASSET__55ce5672__"